import Vue from 'vue'
import { login, logout, phoneLogin, thirdLogin,loginVerifyUsernameAndPassword } from "@/api/login"
import { ACCESS_TOKEN, USER_NAME,USER_INFO,USER_AUTH,SYS_BUTTON_AUTH,UI_CACHE_DB_DICT_DATA,TENANT_ID,CACHE_INCLUDED_ROUTES, TIME_DIFFERENCE,MENUS } from "@/store/mutation-types"
import { welcome } from "@/utils/util"
import { queryPermissionsByUser, queryUserLanguage,ssoIn,ssoInVendor } from '@/api/api'
import { getAction } from '@/api/manage'

import router from '@/router/index'
import store from "../index";

const user = {
  state: {
    languageList:[],
    language: {},
    token: '',
    username: '',
    realname: '',
    tenantid:'',
    welcome: '',
    avatar: '',
    applicationCode:'',
    application:{},
    pageList:[],
    linkList:[],
    permissionList: [],
    info: {},
    contractorAdminFlag: false,//劳安承揽商管理员标记
  },

  mutations: {
    SET_LANGUAGELIST:(state, languageList)=>{
      state.languageList = languageList
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { username, realname, welcome }) => {
      state.username = username
      state.realname = realname
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_PERMISSIONLIST: (state, permissionList) => {
      state.permissionList = permissionList
    },
    SET_APPLICATION_CODE: (state, applicationCode) => {
      state.applicationCode = applicationCode
    },
    SET_APPLICATION: (state, application) => {
      state.application = application
    },
    SET_PAGE_LIST: (state, pageList) => {
      state.pageList = pageList
    },
    SET_LIKE_LIST: (state, linkList) => {
      state.linkList = linkList
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_TENANT: (state, id) => {
      state.tenantid = id
    },
    SET_CONTRACTOR_ADMIN_FLAG: (state, contractorAdminFlag) => {
      state.contractorAdminFlag = contractorAdminFlag
    },
  },

  actions: {
    //多语言
    GetLanguage({ commit }, langCode){
      window.sessionStorage.setItem('USER_LANGUAGE', langCode);
      return new Promise((resolve, reject) => {
        queryUserLanguage({ langCode }).then(response => {
          console.log("----cas 多语言--------",response);
          if(response.code === 200 && response.success){
            commit('SET_LANGUAGE', response.result)
            window.sessionStorage.setItem(TIME_DIFFERENCE, new Date(response.timestamp).getTime() - new Date().getTime());
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // CAS验证登录
    ValidateLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        getAction("/sys/cas/client/validateLogin",userInfo).then(response => {
          console.log("----cas 登录--------",response);
          if(response.success){
            const result = response.result
            const userInfo = result.userInfo
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            commit('SET_INFO', userInfo)
            commit('SET_NAME', { username: userInfo.username,realname: userInfo.realname, welcome: welcome() })
            commit('SET_AVATAR', userInfo.avatar)
            resolve(response)
          }else{
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginVerify({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginVerifyUsernameAndPassword(userInfo).then(response => {
          if(response.code =='200'){
            const result = response.result
            const userInfo = result.userInfo
            /*Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)*/
            /*Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
            /!*commit('SET_TOKEN', result.token)*!/
            commit('SET_INFO', userInfo)
            commit('SET_NAME', { username: userInfo.username,realname: userInfo.realname, welcome: welcome() })
            commit('SET_AVATAR', userInfo.avatar)*/
            resolve(response)
          }else{
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          if(response.code =='200'){
            const result = response.result
            const userInfo = result.userInfo
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            commit('SET_INFO', userInfo)
            commit('SET_NAME', { username: userInfo.username,realname: userInfo.realname, welcome: welcome() })
            commit('SET_AVATAR', userInfo.avatar)
            resolve(response)
          }else{
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // SSO授權登錄
    SsoLogin({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        ssoIn(payload).then(response => {
          const { success, result } = response || {};
          if(success) {
            const result = response.result
            const userInfo = result.userInfo
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            commit('SET_INFO', userInfo)
            commit('SET_NAME', { username: userInfo.username,realname: userInfo.realname, welcome: welcome() })
            commit('SET_AVATAR', userInfo.avatar)
            resolve(response)
          } else{
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    SsoLoginVendor({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        ssoInVendor(payload).then(response => {
          const { success, result } = response || {};
          if(success) {
            const result = response.result
            const userInfo = result.userInfo
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            commit('SET_INFO', userInfo)
            commit('SET_NAME', { username: userInfo.username,realname: userInfo.realname, welcome: welcome() })
            commit('SET_AVATAR', userInfo.avatar)
            resolve(response)
          } else{
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    //手机号登录
    PhoneLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
          phoneLogin(userInfo).then(response => {
          if(response.code =='200'){
        const result = response.result
        const userInfo = result.userInfo
        Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
        Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
        Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
        Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
        commit('SET_TOKEN', result.token)
        commit('SET_INFO', userInfo)
        commit('SET_NAME', { username: userInfo.username,realname: userInfo.realname, welcome: welcome() })
        commit('SET_AVATAR', userInfo.avatar)
        resolve(response)
      }else{
        reject(response)
      }
    }).catch(error => {
        reject(error)
      })
    })
    },

    //获取用户应用
    GetApplicationByUser({ commit }) {
      return new Promise((resolve, reject) => {
        getAction('/sys/sysBmApplication/queryListByUser').then(response => {
          if (response.success) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    LaborContractorAdminFlag({ commit },applicationCode){
      return new Promise((resolve, reject) => {
        if(applicationCode === 'labor'){
          let roleCodes = Vue.ls.get(USER_INFO)?Vue.ls.get(USER_INFO).roleCodes:null;
          if(roleCodes){
            for(let value of roleCodes.split(';')){
              let str = value.split(":");
              if(str[0] === 'labor' && str[1].indexOf('LABOR_CONTRACTOR') > -1){
                commit('SET_CONTRACTOR_ADMIN_FLAG', true);
                break;
              }
            }
          }
          resolve();
        } else {
          reject();
        }
      })
    },
    async setLangCode({ commit },appCode){
      await getAction("/sys/sysBmApplication/queryLanguageByCode",{code:appCode}).then(res=> {
        if (res.success) {
          let languageSettings = res.result
          let langCode = window.sessionStorage.getItem('USER_LANGUAGE');
          if (languageSettings) {
            let languages = languageSettings.split(",");
            if (languageSettings.indexOf(langCode) == -1) {
              // window.sessionStorage.setItem('USER_LANGUAGE', languages[0]);
              store.dispatch('GetLanguage',languages[0])
            }
          }
        }
      })
    },
    // 获取用户信息
    async GetPermissionListByCode({ commit },applicationCode) {
      await store.dispatch('setLangCode',applicationCode);
      return new Promise((resolve, reject) => {
        queryPermissionsByUser({applicationCode}).then(response => {
          const menuData = response.result.menu;
          const authData = response.result.auth;
          const allAuthData = response.result.allAuth;
          //Vue.ls.set(USER_AUTH,authData);
          sessionStorage.setItem(USER_AUTH,JSON.stringify(authData));
          sessionStorage.setItem(SYS_BUTTON_AUTH,JSON.stringify(allAuthData));
          Vue.ls.set(MENUS, menuData)

          /************* Labor project *************/
          if(applicationCode === 'labor'){
            let roleCodes = Vue.ls.get(USER_INFO)?Vue.ls.get(USER_INFO).roleCodes:null;
            if(roleCodes){
              for(let value of roleCodes.split(';')){
                let str = value.split(":");
                if(str[0] === 'labor' && str[1].indexOf('LABOR_CONTRACTOR') > -1){
                  commit('SET_CONTRACTOR_ADMIN_FLAG', true);
                  break;
                }
              }
            }
          }
          if (menuData && menuData.length > 0) {
            commit('SET_PERMISSIONLIST', menuData)
            commit('SET_APPLICATION_CODE', applicationCode)
            getAction("/sys/sysBmApplication/queryByCode", {code:applicationCode}).then((res) => {
              if (res.success) {
                commit('SET_APPLICATION',res.result)
              }
            })
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })

      })
    },

    // 获取用户信息
    async GetPermissionList({ commit },applicationCode) {
      await store.dispatch('setLangCode',applicationCode);
      return new Promise((resolve, reject) => {
        queryPermissionsByUser({applicationCode}).then(response => {
          const menuData = response.result.menu;
          const authData = response.result.auth;
          const allAuthData = response.result.allAuth;
          //Vue.ls.set(USER_AUTH,authData);
          sessionStorage.setItem(USER_AUTH,JSON.stringify(authData));
          sessionStorage.setItem(SYS_BUTTON_AUTH,JSON.stringify(allAuthData));

          Vue.ls.set(MENUS, menuData)

          if (menuData && menuData.length > 0) {
            //update--begin--autor:qinfeng-----date:20200109------for：JEECG-63 一级菜单的子菜单全部是隐藏路由，则一级菜单不显示------
            menuData.forEach((item, index) => {
              if (item["children"]) {
                let hasChildrenMenu = item["children"].filter((i) => {
                  return !i.hidden || i.hidden == false
                })
                if (hasChildrenMenu == null || hasChildrenMenu.length == 0) {
                  item["hidden"] = true
                }
              }
            })
            //console.log(" menu show json ", menuData)
            //update--end--autor:qinfeng-----date:20200109------for：JEECG-63 一级菜单的子菜单全部是隐藏路由，则一级菜单不显示------

         //   commit('SET_PERMISSIONLIST', menuData)
         //   commit('SET_APPLICATION_CODE', applicationCode)
          } else {
       //     alert('4444')
            router.push({ path: "/exception/404" })

           reject('getPermissionList: permissions must be a non-null array !')
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })

      })
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        let logoutToken = state.token;
        commit('SET_TOKEN', '')
        commit('SET_PERMISSIONLIST', [])
        Vue.ls.remove(ACCESS_TOKEN)
        Vue.ls.remove(USER_INFO)
        Vue.ls.remove(USER_NAME)
        Vue.ls.remove(UI_CACHE_DB_DICT_DATA)
        Vue.ls.remove(CACHE_INCLUDED_ROUTES)
        Vue.ls.remove(TENANT_ID)
        Vue.ls.remove(MENUS)
        //console.log('logoutToken: '+ logoutToken)
        logout(logoutToken).then(() => {
          if (process.env.VUE_APP_SSO == 'true') {
            let sevice = 'http://' + window.location.host + '/'
            let serviceUrl = encodeURIComponent(sevice)
            window.location.href = process.env.VUE_APP_CAS_BASE_URL + '/logout?service=' + serviceUrl
          }
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    },
    // 第三方登录
    ThirdLogin({ commit }, param) {
      return new Promise((resolve, reject) => {
        thirdLogin(param.token,param.thirdType).then(response => {
          if(response.code =='200'){
            const result = response.result
            const userInfo = result.userInfo
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            commit('SET_INFO', userInfo)
            commit('SET_NAME', { username: userInfo.username,realname: userInfo.realname, welcome: welcome() })
            commit('SET_AVATAR', userInfo.avatar)
            resolve(response)
          }else{
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    saveTenant({ commit }, id){
      Vue.ls.set(TENANT_ID, id, 7 * 24 * 60 * 60 * 1000)
      commit('SET_TENANT', id)
    }


  }
}

export default user